<ng-container *transloco="let t; read: 'findMyAgent.results'">
  <div class="mt-8 pr-4">
    <p class="text-heading-3">{{ t('price-expectation.title') }}</p>
    @if (result !== 'None') {
      <p>{{ t('price-expectation.subtitle', { name: shortName | possessive }) }}</p>
      <p class="mt-2 flex w-fit items-center rounded-sm px-3 py-2 font-bold" [ngClass]="priceExcpectationViewModel?.styles">
        @if (priceExcpectationViewModel?.icon; as icon) {
          <rma-icon [glyph]="icon" />
        }
      </p>
    } @else {
      <p>{{ t('price-expectation.no-data', { name: shortName }) }}</p>
    }
  </div>
</ng-container>
